// src/firebaseApp.ts
import { initializeApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";

const firebaseConfigV3 = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY_V3,
  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN_V3,
  projectId: "farm-functions-v3",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET_V3,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID_V3,
  appId: process.env.REACT_APP_FIREBASE_APPID_V3,
};

const appV3 = initializeApp(firebaseConfigV3, "v3");
const functionsV3 = getFunctions(appV3, "us-central1");

export { functionsV3, httpsCallable };
